import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../redux_files/actions/page_actions';
import WhatWeOfferConsts from "../json_config/what-we-offer.json";

const WhatWeOffer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'What We offer';
    dispatch(pageAction('What We offer'));
  });
  return (
    <>
      <div className='container'>
        <div className='outer-border pd-20'>
          {
            WhatWeOfferConsts.map((data) => {
              return (
                <div key={data.subTitle}>
                  <div className='title'>{data.subTitle}</div>
                  <div className='description'>{data.description}</div>
                </div>
              )
            })
          }
        <br />
        </div>
      </div>
    </>
  );
};

export default WhatWeOffer;
